const adminColors = {};

export default adminColors;
